import React from "react"

import PopoverMenuSeparator
    from "../../../../../../core/gd-components/popover-menu/popover-menu/popover-menu-separator"
import PageSettingsMenuOption from "./menu-option"
import page_toggleFullWidth from "../../../actions/page-toggle-full-width"
import page_toggleShowControls from "../../../actions/page-toggle-show-controls"
import {PageContentInterface} from "../../page-content-interface"
import page_toggleCreatedBy from "../../../actions/page-toggle-created-by";
import page_toggleLastUpdatedBy from "../../../actions/page-toggle-last-updated-by";

type Props = {
    menuParams  : {
        app: PageContentInterface
    }
    hidePopover : func
}

// const debug = "PageSettingsMenuOptions"
const debug = false

export default function PageSettingsMenuOptions(props: Props) {

    const onShowControlsChange = (value:boolean) => {
        debug && console.log(debug, 'onShowControlsChange', value)
        page_toggleShowControls(value)
    }

    const onFullWidthChange = (value:boolean) => {
        debug && console.log(debug, 'onFullWidthChange', value)
        page_toggleFullWidth(value)
    }

    const onCreatedByChange = (value:boolean) => {
        debug && console.log(debug, 'onCreatedByChange', value)
        page_toggleCreatedBy(value)
    }

    const onLatsUpdatedChange = (value:boolean) => {
        debug && console.log(debug, 'onLatsUpdatedChange', value)
        page_toggleLastUpdatedBy(value)
    }

    const showControlPanel = {
        label   : 'Show control panel',
        value   : props.menuParams.app.editorLocalSettings.showControls,
        disabled: false,
        onClick : onShowControlsChange
    }

    const textFullWidth = {
        label   : 'Text full width',
        value   : props.menuParams.app.settings?.isFullWidth,
        disabled: false,
        onClick : onFullWidthChange
    }

    const createdBy = {
        label   : 'Created by',
        value   : props.menuParams.app.settings?.showCreatedBy,
        disabled: false,
        onClick : onCreatedByChange
    }

    const lastUpdatedBy = {
        label   : 'Last updated by',
        value   : props.menuParams.app.settings?.showLastUpdatedBy,
        disabled: false,
        onClick : onLatsUpdatedChange
    }

    return (
        <div className="ui5-popover-menu" style={{width: 230}}>

            <PageSettingsMenuOption option={showControlPanel}/>
            <PageSettingsMenuOption option={textFullWidth}/>

            <PopoverMenuSeparator/>

            <PageSettingsMenuOption option={createdBy}/>
            <PageSettingsMenuOption option={lastUpdatedBy}/>

        </div>
    )
}